import { isExpEditor } from '../lib/lib'
import Swiper from 'swiper/bundle'

class marketingSwiper {
  constructor(element) {
    if (!element) {
      return false
    }

    if (isExpEditor()) {
      return false
    }

    this.strip = jQuery(element)

    const swiper = new Swiper(this.strip.find('.swiper')[0], {
      direction: 'horizontal',
      effect: 'slide',
      slidesPerView: 4,
      centeredSlides: false,
      breakpoints: {
        320: {
          slidesPerView: 1.05,
          spaceBetween: 8,
        },
        576: {
          slidesPerView: 1.75,
          spaceBetween: 8,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        1366: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1439: {
          slidesPerView: 4,
          spaceBetween: 32,
        },
      },
      pagination: {
        el: this.strip.find('.swiper-pagination')[0],
        type: 'bullets',
        clickable: true,
      },
    })
  }
}

export default marketingSwiper
